<template>
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item
      :to="{ path: item.link }"
      v-for="(item, index) in breadcrumbList"
      :key="index"
      >{{ item.breadcrumb }}</el-breadcrumb-item
    >
  </el-breadcrumb>
</template>

<script>
export default {
  props: {
    breadcrumbList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.el-breadcrumb {
  padding: 20px 0;
  &__item {
    .el-breadcrumb__inner {
      color: $--color-dark-gray;
      font: {
        weight: $--font-weight-default;
        size: $--font-size-base;
      }
      &.is-link,
      a {
        color: $--color-dark-gray;
        font: {
          weight: $--font-weight-default;
          size: $--font-size-base;
        }
      }
    }
    &:last-child {
      .el-breadcrumb__inner {
        color: $--color-dark-gray;
      }
    }
  }
}
</style>
